// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    ListItemIcon,
    ListItemText, Tooltip
} from "@mui/material";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import VisibilityIcon from '@mui/icons-material/Visibility';

// App Imports
import {changeContractDrilldownCDP} from "./contractDrilldownSliceCDP";
import {changeContractDataPointValue} from "../../ContractDataPointValue/contractDataPointValueSlice";
import {deleteContractCDP, moveCDP, orderCDPinCS} from "../../ContractDataPoint/ContractDataPointClient";
import {changeContractDrilldownCDPV} from "../ContractDrilldownCDPV/contractDrilldownSliceCDPV";
import {changeContractDataPoint} from "../../ContractDataPoint/contractDataPointSlice";
import {changeContractDrilldownCDPVF} from "../ContractDrilldownCDPVF/contractDrilldownSliceCDPVF";
import {deleteSingleContract} from "../../Contract/ContractClient";
import {changeContract} from "../../Contract/contractSlice";
import Button from "@mui/material/Button";
import {deleteContractDataPointValue} from "../../ContractDataPointValue/ContractDataPointValueClient";
import {
    deleteContractDataPointValueFilter, getCDPVFbyCDPid
} from "../../ContractDataPointValueFilter/ContractDataPointValueFilterClient";
import {changeCrudSnackbar} from "../../CommonComponents/crudSnackbarSlice";


// main function
export default function ContractDrilldownCdpGridMenu(props) {

    // ****************** BEGIN STATES ****************************

    const [anchorEl, setAnchorEl] = React.useState(null);

    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const selectorContractDataPointId = useSelector((state) => state.contractDataPointSlc.value.id);
    const selectorCdpvId = useSelector((state) => state.contractDataPointSlc.value.cdpvId);
    const selectorCdpvfId = useSelector((state) => state.contractDataPointSlc.value.cdpvfId);
    const selectorCdpvCdpvfId = useSelector((state) => state.contractDataPointSlc.value.cdpvCdpvfId);
    const selectorContractSectionId = useSelector((state) => state.contractDataPointSlc.value.contractSectionId);
    const selectorCdpvCount = useSelector((state) => state.contractDataPointSlc.value.cdpvCount);
    const selectorCdpvfCount = useSelector((state) => state.contractDataPointSlc.value.cdpvfCount);

    // ********************** END STORE ********************************


    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************


    const isMenuOpen = Boolean(anchorEl);


    // ***************** BEGIN CONTROLS ***************************

    const handleCrudMenuOpen = (event) => {
        console.log("this should be the index");
        console.log(event.currentTarget.index);
        setAnchorEl(event.currentTarget);
    };


    const handleMenuClose = () => {
        setAnchorEl(null);
    };


    const handleEdit = () => {
        handleMenuClose();
        dispatchData(changeContractDataPoint({cdpDrawerState: true, cdpDrawerMode: "Edit"}))
        console.log("Edit triggered");

    };



    // ==== begin CDP delete

    // const handleDeleteCdp = () => {
    //     console.log("deleting this contract data point id");
    //     console.log(selectorContractDataPointId);
    //     deleteContractCDP(selectorContractDataPointId).then(
    //         orderCDPinCS(selectorContractSectionId)).then(
    //         orderCDPinCS(selectorContractSectionId)).then(
    //         dispatchData(changeContractDataPoint({cdpGridRefresh: true})))
    // };

    const [confirmCdpDeleteOpen, setConfirmCdpDeleteOpen] = React.useState(false);

    const handleConfirmCdpDeleteClose = () => setConfirmCdpDeleteOpen(false);

    const handleDeleteCdp = () => {
        setConfirmCdpDeleteOpen(true);
        setAnchorEl(null);
    };


    const handleConfirmCdpDelete = () => {
        console.log("deleting this contract data point id");
        console.log(selectorContractDataPointId);
        deleteContractCDP(selectorContractDataPointId)
            .then(()=>{
            orderCDPinCS(selectorContractSectionId)
            .then(()=>{
            orderCDPinCS(selectorContractSectionId)
            .then(()=> {
                    dispatchData(changeContractDataPoint({cdpGridRefresh: true}))
                })})})
            .catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Deletion failed"}));
            })
            .finally(() => {
                setConfirmCdpDeleteOpen(false);
            })


        // console.log("contract to be deleted = ", selectorContractId2);
        // setConfirmOpen(false);
    };

    // ==== end CDP delete cdp


    // ==== begin CDPD delete

    // const handleDeleteCdp = () => {
    //     console.log("deleting this contract data point id");
    //     console.log(selectorContractDataPointId);
    //     deleteContractCDP(selectorContractDataPointId).then(
    //         orderCDPinCS(selectorContractSectionId)).then(
    //         orderCDPinCS(selectorContractSectionId)).then(
    //         dispatchData(changeContractDataPoint({cdpGridRefresh: true})))
    // };

    const [confirmSingleCdpvDeleteOpen, setConfirmSingleCdpvDeleteOpen] = React.useState(false);

    const handleConfirmSingleCdpvDeleteClose = () => setConfirmSingleCdpvDeleteOpen(false);

    const handleDeleteCdpv = () => {
            if(selectorCdpvCount === 1) {
                setConfirmSingleCdpvDeleteOpen(true);
                setAnchorEl(null);
            }
        if(selectorCdpvCount > 1) {
            handleMenuClose();
            dispatchData(changeContractDrilldownCDP({id: selectorContractDataPointId}));
            dispatchData(changeContractDrilldownCDPV({cdpvGridState: true}));
            dispatchData(changeContractDataPointValue({cdpvGridState: true, cdpvDrawerMode: "Delete", cdpvViewValueOnly: false}));
        }
    };


    const handleConfirmSingleCdpvDelete = () => {
        console.log("deleting this contract data point value id");
        console.log(selectorCdpvId);
        deleteContractDataPointValue(selectorCdpvId).then(
            // orderCDPinCS(selectorContractSectionId)).then(
            // orderCDPinCS(selectorContractSectionId)).then(
            dispatchData(changeContractDataPoint({cdpGridRefresh: true})))
            .then(() => {
                setConfirmSingleCdpvDeleteOpen(false);
            });
        // console.log("contract to be deleted = ", selectorContractId2);
        // setConfirmOpen(false);
    };

    // ==== end CDPD delete


    // ==== begin CDPDF delete

    // const handleDeleteCdp = () => {
    //     console.log("deleting this contract data point id");
    //     console.log(selectorContractDataPointId);
    //     deleteContractCDP(selectorContractDataPointId).then(
    //         orderCDPinCS(selectorContractSectionId)).then(
    //         orderCDPinCS(selectorContractSectionId)).then(
    //         dispatchData(changeContractDataPoint({cdpGridRefresh: true})))
    // };

    const [confirmSingleCdpvfDeleteOpen, setConfirmSingleCdpvfDeleteOpen] = React.useState(false);

    const handleConfirmSingleCdpvfDeleteClose = () => setConfirmSingleCdpvfDeleteOpen(false);

    const handleDeleteCdpvf = () => {
        console.log("selectorCdpvCount = ",selectorCdpvCount);
        console.log("selectorCdpvfCount = ", selectorCdpvfCount);
        if((selectorCdpvCount === 0 && selectorCdpvfCount === 1) ||
            (selectorCdpvCount === 1 && selectorCdpvfCount === 1 && selectorCdpvId !== selectorCdpvCdpvfId)){
            setConfirmSingleCdpvfDeleteOpen(true);
            setAnchorEl(null);
        }
        if(selectorCdpvfCount > 1) {
            // setShowCdpvfGrid(!showCdpvfGrid);
            console.log("Opening cdpvf grid to delete");
            // dispatchData(changeContractDrilldownCDP({id: selectedCDP, filterId: null}));
            // dispatchData(changeContractDataPointValueFilter({cdpvfGridState: true}));
            dispatchData(changeContractDrilldownCDPVF({cdpvfGridState: true}));
            setAnchorEl(null);
        }

    };


    const handleConfirmSingleCdpvfDelete = () => {
        console.log("deleting this contract data point value filter id");
        console.log(selectorCdpvfId);
        deleteContractDataPointValueFilter(selectorCdpvfId).then(
            // orderCDPinCS(selectorContractSectionId)).then(
            // orderCDPinCS(selectorContractSectionId)).then(
            dispatchData(changeContractDataPoint({cdpGridRefresh: true})))
            .then(() => {
                setConfirmSingleCdpvfDeleteOpen(false);
            });
        // console.log("contract to be deleted = ", selectorContractId2);
        // setConfirmOpen(false);
    };

    // ==== end CDPVF delete



    const handleMoveUp = () => {
        moveCDP(selectorContractDataPointId, 'UP')
            .then(() =>
                dispatchData(changeContractDataPoint({cdpGridRefresh: true})))
    };


    const handleMoveDown = () => {
        moveCDP(selectorContractDataPointId, 'DOWN')
            .then(() =>
                dispatchData(changeContractDataPoint({cdpGridRefresh: true})))
    };


    const handleViewValue = () => {
        if(selectorCdpvCount === 1) {
            handleMenuClose();
            dispatchData(changeContractDataPointValue({cdpvDrawerState: true,  cdpvDrawerContext: "cdpGrid",cdpvDrawerMode: "View", cdpvViewValueOnly: false}));}
        if(selectorCdpvCount > 1) {
            handleMenuClose();
            dispatchData(changeContractDrilldownCDP({id: selectorContractDataPointId}));
            dispatchData(changeContractDrilldownCDPV({cdpvGridState: true}));
            dispatchData(changeContractDataPointValue({cdpvGridState: true, cdpvDrawerMode: "View", cdpvViewValueOnly: false}));
        }
    };


    const handleAddValue = () => {
        handleMenuClose();
        dispatchData(changeContractDataPointValue({id: null,
            contractDataPointId: selectorContractDataPointId,
            ordinalNumber: null, iterationNumber: null,
            extendInd: false, value: null, expression: null, expressionDescription: null, expressionTranslation: null,
            sourceContractDataPointValueId: null, origin: null, contractDataPointValueFilterId: null,
            status: null, mockValue: null,defaultValue: null,
            createdOn: null, createdBy: null, lastModifiedOn: null, lastModifiedBy: null,
            cdpvDrawerState: true, cdpvDrawerContext: "cdpGrid", cdpvDrawerMode: "Add", cdpvViewValueOnly: false}));
    };


    const handleEditValue = () => {
        console.log("handleEditValue called from cdp menu");
        console.log("selectorCdpvCount = ",selectorCdpvCount);
        console.log("selectorCdpvId = ", selectorCdpvId);
    if(selectorCdpvCount === 1) {
        handleMenuClose();
        dispatchData(changeContractDataPointValue({cdpvDrawerState: true,  cdpvDrawerContext: "cdpGrid",cdpvDrawerMode: "Edit", cdpvViewValueOnly: false}));}
        if(selectorCdpvCount > 1) {
            handleMenuClose();
            dispatchData(changeContractDrilldownCDP({id: selectorContractDataPointId}));
            dispatchData(changeContractDrilldownCDPV({cdpvGridState: true}));
            dispatchData(changeContractDataPointValue({cdpvGridState: true, cdpvDrawerMode: "Edit", cdpvViewValueOnly: false}));
    }
    };


    const handleDeleteValue = () => {
    };


    const handleViewFilters = () => {
        if(selectorCdpvfCount === 1) {
            console.log("Opening cdpvf form to view");
            console.log("selectorCdpvfId", selectorCdpvfId);
            console.log("selectorContractDataPointId", selectorContractDataPointId);
            getCDPVFbyCDPid(selectorContractDataPointId)
                .then(function(res){

            dispatchData(changeContractDrilldownCDPVF({
                id: res[0].id,
                contractDataPointId: res[0].contractDataPointId,
                contractDataPointValueId: res[0].contractDataPointValueId,
                parentFilterId: res[0].parentFilterId,
                previousFilterId: res[0].previousFilterId,
                ordinalNumber: res[0].ordinalNumber,
                recordLevel: res[0].recordLevel,
                dataPointId: res[0].dataPointId,
                singleValue: res[0].singleValue,
                singleValueNumber: res[0].singleValueNumber,
                fromValue: res[0].fromValue,
                toValue: res[0].toValue,
                status: res[0].status,
                hierarchy: res[0].hierarchy,
                cdpvMockValue: res[0].cdpvMockValue,
                expressionIndicator: res[0].expressionIndicator,
                mockExpression: res[0].mockExpression,
                mockExpressionTranslation: res[0].mockExpressionTranslation,
                createdOn: res[0].createdOn,
                createdBy: res[0].createdBy,
                lastModifiedOn: res[0].lastModifiedOn,
                lastModifiedBy: res[0].lastModifiedBy,
                expressionIndicatorOld: res[0].expressionIndicatorOld,
                mockExpressionOld: res[0].mockExpressionOld,
                mockExpressionTranslationOld: res[0].mockExpressionTranslationOld,
                cdpvCount: res[0].cdpvCount,
                dataPointName: res[0].dataPointName,
                dataType: res[0].dataType,
                displaySingleValue: res[0].displaySingleValue,
                displayFromValue: res[0].displayFromValue,
                displayToValue: res[0].displayToValue,
                cdpDataPointId: res[0].cdpDataPointId,
                cdpDataPointName: res[0].cdpDataPointName,
                cdpDataType: res[0].cdpDataType,
                mockOrigin: res[0].mockOrigin,
                cdpvValue: res[0].cdpvValue,
                expression: res[0].expression,
                expressionTranslation:  res[0].expressionTranslation,
                expressionDescription:  res[0].expressionDescription,
                mockValue: res[0].mockValue,
                parentDataPointId:  res[0].parentDataPointId,
                parentDataPointName:  res[0].parentDataPointName,
                parentDataType:  res[0].parentDataType,
                parentDisplaySingleValue:  res[0].parentDisplaySingleValue,
                parentDisplayFromValue:  res[0].parentDisplayFromValue,
                parentDisplayToValue:  res[0].parentDisplayToValue,
                cdpvId: res[0].cdpvId,
                cdpvfDrawerState: true ,cdpvfDrawerContext: "cdpGrid" ,cdpvfDrawerMode: "View"
            }))});
            setAnchorEl(null);
        }
        if(selectorCdpvfCount > 1) {
            console.log("Opening cdpvf grid to view");
            dispatchData(changeContractDrilldownCDPVF({cdpvfGridState: true}));
            setAnchorEl(null);
        }
    };


    const handleAddFilter = () => {
        handleMenuClose();
        dispatchData(changeContractDrilldownCDPVF
        // dispatchData(changeContractDataPointValueFilter
        ({id: null, contractDataPointId: selectorContractDataPointId,
            contractDataPointValueId: null,
            parentFilterId: null, previousFilterId: null, ordinalNumber: null, recordLevel: null,
            dataPointId: null, singleValue: null, fromValue: null, toValue: null,
            status: null, hierarchy: null, mockValue: null, expressionIndicator: null,
            mockExpression: null, mockExpressionTranslation: null,
            createdOn: null,createdBy: null,lastModifiedOn: null,lastModifiedBy: null,
            cdpvfGridState: false,
            cdpvfDrawerState: true ,cdpvfDrawerContext: "cdpGrid" ,cdpvfDrawerMode: "Add"}));
        // dispatchData(changeContractDrilldownCDPVF({ cdpvfDrawerState: true, cdpvfDrawerMode: "Add"}));
        dispatchData(changeContractDrilldownCDP({ id: selectorContractDataPointId}));
    };


    const handleEditFilter = () => {
        if(selectorCdpvfCount === 1) {
            console.log("Opening cdpvf form to edit");
            console.log("selectorCdpvfId", selectorCdpvfId);
            console.log("selectorContractDataPointId", selectorContractDataPointId);
            getCDPVFbyCDPid(selectorContractDataPointId)
                .then(function(res){

                    dispatchData(changeContractDrilldownCDPVF({
                        id: res[0].id,
                        contractDataPointId: res[0].contractDataPointId,
                        contractDataPointValueId: res[0].contractDataPointValueId,
                        parentFilterId: res[0].parentFilterId,
                        previousFilterId: res[0].previousFilterId,
                        ordinalNumber: res[0].ordinalNumber,
                        recordLevel: res[0].recordLevel,
                        dataPointId: res[0].dataPointId,
                        singleValue: res[0].singleValue,
                        singleValueNumber: res[0].singleValueNumber,
                        fromValue: res[0].fromValue,
                        toValue: res[0].toValue,
                        status: res[0].status,
                        hierarchy: res[0].hierarchy,
                        cdpvMockValue: res[0].cdpvMockValue,
                        expressionIndicator: res[0].expressionIndicator,
                        mockExpression: res[0].mockExpression,
                        mockExpressionTranslation: res[0].mockExpressionTranslation,
                        createdOn: res[0].createdOn,
                        createdBy: res[0].createdBy,
                        lastModifiedOn: res[0].lastModifiedOn,
                        lastModifiedBy: res[0].lastModifiedBy,
                        expressionIndicatorOld: res[0].expressionIndicatorOld,
                        mockExpressionOld: res[0].mockExpressionOld,
                        mockExpressionTranslationOld: res[0].mockExpressionTranslationOld,
                        cdpvCount: res[0].cdpvCount,
                        dataPointName: res[0].dataPointName,
                        dataType: res[0].dataType,
                        displaySingleValue: res[0].displaySingleValue,
                        displayFromValue: res[0].displayFromValue,
                        displayToValue: res[0].displayToValue,
                        cdpDataPointId: res[0].cdpDataPointId,
                        cdpDataPointName: res[0].cdpDataPointName,
                        cdpDataType: res[0].cdpDataType,
                        mockOrigin: res[0].mockOrigin,
                        cdpvValue: res[0].cdpvValue,
                        expression: res[0].expression,
                        expressionTranslation:  res[0].expressionTranslation,
                        expressionDescription:  res[0].expressionDescription,
                        mockValue: res[0].mockValue,
                        parentDataPointId:  res[0].parentDataPointId,
                        parentDataPointName:  res[0].parentDataPointName,
                        parentDataType:  res[0].parentDataType,
                        parentDisplaySingleValue:  res[0].parentDisplaySingleValue,
                        parentDisplayFromValue:  res[0].parentDisplayFromValue,
                        parentDisplayToValue:  res[0].parentDisplayToValue,
                        cdpvId: res[0].cdpvId,
                        cdpvfDrawerState: true ,cdpvfDrawerContext: "cdpGrid" ,cdpvfDrawerMode: "Edit"
                    }))});
            setAnchorEl(null);
        }
        if(selectorCdpvfCount > 1) {
            console.log("Opening cdpvf grid to edit");
            dispatchData(changeContractDrilldownCDPVF({cdpvfGridState: true}));
            setAnchorEl(null);
        }
    };
    //
    // const handleDeleteFilter = () => {
    // };

    // *************** END CONTROLS *******************************

    const crudId = 'primary-search-account-menu';


    const renderMenu = (

        <Menu
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            id={crudId}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={isMenuOpen}
            onClose={handleMenuClose}
        >
            {/*<MenuItem onClick={handleAdd}>*/}
            {/*    <ListItemIcon>*/}
            {/*        <AddCircleOutlineIcon fontSize="small" />*/}
            {/*    </ListItemIcon>*/}
            {/*    <ListItemText>Add</ListItemText>*/}
            {/*</MenuItem>*/}


            <MenuItem onClick={handleEdit}>
                <ListItemIcon>
                    <EditIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Edit</ListItemText>
            </MenuItem>
            <MenuItem onClick={handleDeleteCdp}>
                <ListItemIcon>
                    <DeleteOutlineIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Delete</ListItemText>
               </MenuItem>

            <Dialog open={confirmCdpDeleteOpen} onClose={handleConfirmCdpDeleteClose}>
                <DialogTitle>Confirm Contract Data Point Delete</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this Contract Data Point? This action cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleConfirmCdpDeleteClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleConfirmCdpDelete} color="error">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>

            <MenuItem onClick={handleMoveUp}>
                <ListItemIcon>
                    <ArrowUpwardIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Move Up</ListItemText>
            </MenuItem>
            <MenuItem onClick={handleMoveDown}>
                <ListItemIcon>
                    <ArrowDownwardIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Move Down</ListItemText>
            </MenuItem>
            <MenuItem onClick={handleViewValue}>
                <ListItemIcon>
                    <VisibilityIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>View Value(s)</ListItemText>
            </MenuItem>
            <MenuItem onClick={handleAddValue}>
                <ListItemIcon>
                    <AddCircleOutlineIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Add Value</ListItemText>
            </MenuItem>
            <MenuItem onClick={handleEditValue}>
                <ListItemIcon>
                    <EditIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Edit Value(s)</ListItemText>
            </MenuItem>
                    <MenuItem onClick={handleDeleteCdpv}>
        <ListItemIcon>
            <DeleteOutlineIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Delete Value(s)</ListItemText>
</MenuItem>

            <Dialog open={confirmSingleCdpvDeleteOpen} onClose={handleConfirmSingleCdpvDeleteClose}>
                <DialogTitle>Confirm Contract Data Point Value Delete</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this Contract Data Point Value? This action cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleConfirmSingleCdpvDeleteClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleConfirmSingleCdpvDelete} color="error">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>

            <MenuItem onClick={handleViewFilters}>
                <ListItemIcon>
                    <VisibilityIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>View Filter(s)</ListItemText>
            </MenuItem>
        <MenuItem onClick={handleAddFilter}>
            <ListItemIcon>
                <AddCircleOutlineIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Add Filter</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleEditFilter}>
            <ListItemIcon>
                <EditIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Edit Filter(s)</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleDeleteCdpvf}>
            <ListItemIcon>
                <DeleteOutlineIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Delete Filter(s)</ListItemText>
    </MenuItem>

            <Dialog open={confirmSingleCdpvfDeleteOpen} onClose={handleConfirmSingleCdpvfDeleteClose}>
                <DialogTitle>Confirm Contract Data Point Value Filter Delete</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this Contract Data Point Value Filter? This action cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleConfirmSingleCdpvfDeleteClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleConfirmSingleCdpvfDelete} color="error">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>

            {/*<MenuItem onClick={handleDeleteFilter}>*/}
            {/*    <ListItemText>cdp {selectorContractDataPointId}</ListItemText>*/}
            {/*</MenuItem>*/}
            {/*<MenuItem onClick={handleDeleteFilter}>*/}
            {/*    <ListItemText>dt {selectorDataType}</ListItemText>*/}
            {/*</MenuItem>*/}
            {/*<MenuItem onClick={handleDeleteFilter}>*/}
            {/*    <ListItemText>cdp {selectorContractDataPointId}</ListItemText>*/}
            {/*</MenuItem>*/}
            {/*<MenuItem onClick={handleDeleteFilter}>*/}
            {/*    <ListItemText>cdpv # {selectorCdpvCount}</ListItemText>*/}
            {/*</MenuItem>*/}
        </Menu>
    );


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Tooltip   enterDelay={1000} enterNextDelay={1000}  title={'Action Menu'}>
<IconButton
    size="large"
    edge="end"
    aria-label="account of current user"
    aria-controls={crudId}
    aria-haspopup="true"
    onClick={handleCrudMenuOpen}
    color="inherit"
>
    <MoreVertIcon  color="primary" fontSize="small"/>
</IconButton>
            </Tooltip>
            {renderMenu}
</div>
);

    // ****************** END RETURN ****************************

}